// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const InfoSheetIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="m12.51 18.23-.02-1.63c-.02-.99-.03-1.76.8-2.59.76-.8 3.68-1.66 4.4-1.66.35 0 1.18.2 2.05.5.22.06.44-.1.44-.32V6.54c0-2.78-2.26-5.04-5.03-5.04H7.4c-2.78 0-5.04 2.26-5.04 5.04v10.64c0 2.78 2.26 5.04 5.04 5.04h6.11c.3 0 .46-.38.26-.61-.74-.86-1.27-1.98-1.27-3.38"
        opacity=".5"
      />
      <path d="M7.27 7.58h5.54c.45 0 .82.37.82.82s-.37.82-.82.82H7.27c-.46 0-.82-.37-.82-.82s.36-.82.82-.82m2.89 6.48h-2.9c-.45 0-.81-.37-.81-.82s.36-.82.81-.82h2.9c.45 0 .82.37.82.82s-.37.82-.82.82" />
      <path
        fillRule="evenodd"
        d="M17.78 13.75c.51 0 3 .8 3.47 1.28.4.4.4.7.38 1.58l-.02 1.66c0 3.08-3.44 4.15-3.59 4.2l-.24.03q-.12 0-.23-.03c-.15-.05-3.59-1.12-3.59-4.2l-.01-1.56v-.1c-.02-.88-.03-1.18.38-1.6.46-.46 2.94-1.26 3.45-1.26m2.2 2.93v-.1l.01-.22v-.22c-.45-.21-1.9-.72-2.24-.75-.27.03-1.67.52-2.18.76v.25l.01.18v.1l.02 1.59c0 1.5 1.57 2.3 2.18 2.54.62-.25 2.2-1.03 2.2-2.54z"
      />
    </g>
  </SvgIcon>
);

export default InfoSheetIcon;
